import React, { Component } from 'react';
import { Button, Modal, Form, Spin } from 'antd';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { actions } from "store";

import MainFieldSet from './MainFieldSet';


class UserForm extends Component {
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                const { actions, user } = this.props;
                const instance = user.editObject;

                let data = Object.assign({}, values);
                if (instance && instance.id) {
                    data.id = instance.id;
                }
                console.log(data);
                actions.userUpdate({ data });
            }
        });
    };

    close = () => {
        const { actions } = this.props;
        actions.userShowEditForm({ show: false });
    };

    render() {
        const { form, user } = this.props;
        const { showEditForm, updateStatus } = user;

        const error = updateStatus.error || {};
        const errorData = error.data || {};

        const isLoading = updateStatus.isLoading;

        return (
            <Modal
                width={600}
                visible={showEditForm}
                title="Редактирование пользователя"
                onCancel={this.close}
                maskClosable={false}
                destroyOnClose={true}
                footer={[
                    <Button key="cancel" onClick={this.close} disabled={isLoading}>Отмена</Button>,
                    <Button key="submit" type="primary" loading={isLoading} onClick={this.handleSubmit}>
                        Сохранить
                    </Button>,
                ]}
            >
                <Spin spinning={isLoading}>
                    <Form onSubmit={this.handleSubmit}>
                        {errorData.non_field_errors &&
                        <div className="form-error">{errorData.non_field_errors}</div>}

                        <MainFieldSet user={user} form={form}/>
                    </Form>
                </Spin>
            </Modal>
        );
    }
}


const WrappedUserForm = Form.create()(UserForm);

function mapStateToProps(state) {
    return {
        user: state.user,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({},
            actions.user,
        ), dispatch),
        dispatch: dispatch
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(WrappedUserForm);

